var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col col-xs-6 col-3 atom-list-circle"},[_vm._m(0),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('AtomsCommonAtomVerticalLine'),_vm._v(" "),_c('AtomsCommonAtomContentText',{attrs:{"color":"#fff","text":`${_vm.text}`}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"circle"},[_c('span')])
}]

export { render, staticRenderFns }